import {ContractProduct, ContractCustomer, ContractExtraCost} from '@api'

import {atom} from 'jotai'

import {initialContractSetupData, initialCustomerData, initialProductData, initialSigningFormData} from './initial-data'
import {ContractFormData, ContractFormSetupData, SigningFormData} from './types'

export const productDataAtom = atom<ContractProduct[]>(initialProductData)
export const customerDataAtom = atom<ContractCustomer>(initialCustomerData)
export const contractSetupDataAtom = atom<ContractFormSetupData>(initialContractSetupData)
export const extraCostsAtom = atom<ContractExtraCost[]>([])

export const contractFormDataAtom = atom<ContractFormData>(get => ({
  productData: get(productDataAtom),
  customerData: get(customerDataAtom),
  contractSetupData: get(contractSetupDataAtom),
  extraCosts: get(extraCostsAtom),
}))

export const signingFormDataAtom = atom<SigningFormData>(initialSigningFormData)
